export enum CustomerClassEnum {
  RES = 'RES',
  SMLCOM = 'SMLCOM',
  LRGCOM = 'LRGCOM',
}
